export const mapAvgRetailPrices = values => {
  if (!values || values.length === 0) {
    return 'N/A'
  }
  if (values.length === 1 && values[0].includes('Under')) {
    return values[0]
  }
  const firstValue = values[0].includes('Under') ? values[0] : values[0].split(' - ')[0]
  values = values.map(price => price.replaceAll(/\$/g, ''))
  const lastValue = values[values.length - 1].includes('+') ? values[values.length - 1] : values[values.length - 1].split(' - ')[1]
  return `${firstValue ?? ''} - ${lastValue ?? ''}`
}
